<template>
    <connect-app
        ref="connectApp"
        v-slot="{ connected, connection }"
        app="freightek"
        logo="/assets/freightek_logo.webp"
        :apis="$url.company.integration.external"
        :connect-function="ftAuth"
        @disconected="handleDisconnect">
        <template v-if="connection">
            <freightek-workspaces
                :connection="connection"
                @change="handleChange" />
        </template>
    </connect-app>
</template>
<script setup lang="ts">
import ConnectApp from '../app.vue'
import FreightekWorkspaces from './freightek-workspaces.vue'
const config = useRuntimeConfig()
const connectApp = ref<any>(null)
const ftAuth = async (backUrl?: string) => {
  const app = 'freightek'
  const cfg = config.public.appConfigs.freightek

  const params: any = {
    client_id: cfg.clientId,
    redirect_uri: `${window.location.origin}/auth/callback-${app}`,
    response_type: 'code',
    scope: 'user-check-status+user-profile+user-email',
    backUrl
  }
  const paramsArr: any = []
  Object.keys(params).forEach((key: string) => {
    const value = params[key]
    paramsArr.push(`${key}=${value}`)
  })
  const paramsStr = paramsArr.join('&')
  const authUrl = `${cfg.accountHost}/oauth/authorize?${paramsStr}`
  window.open(authUrl, 'freightek accounts', 'width=600,height=600')
  const result = await new Promise((resolve) => {
    const messageListen = (event: any) => {
      // Ensure the message is from the expected origin for security
      if (event.origin === window.origin) {
        const authResult = event.data
        window.removeEventListener('message', messageListen)
        resolve(authResult)
      }
    }
    window.addEventListener('message', messageListen)
  })
  return result
}

const handleChange = () => {
  connectApp.value?.refresh()
}

const handleDisconnect = () => {}
</script>
